var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mb-0"},[_c('span',{staticClass:"text-dark font-weight-bold"},[_vm._v(_vm._s(_vm.title)+": ")]),_c('span',{staticClass:"text-muted"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }